__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-manage-bookings-container'].baseUrl;
import ModuleContainer from './components/ContainerWrapper';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/one-app-module-wrapper': '^3.4.2',
      '@americanexpress/travel-selectors': '^5.0.0',
      'fetchye': '^1.1.0',
      'iguazu': '^3.2.0',
      'iguazu-holocron': '^1.2.0',
      'iguazu-rest': '^1.10.1',
      '@americanexpress/reactlytics': '^1.2.8',
      'react-intl': '^6.3.2',
      'moment-timezone': '^0.5.34',
      '@americanexpress/dls-react': '^7.14.0'
    }
  });
}